// extracted by mini-css-extract-plugin
export default {"container":"UploadAndViewFile_container__B76Zr","content":"UploadAndViewFile_content__L+Wm3","fullScreenIcon":"UploadAndViewFile_fullScreenIcon__6fChT"};